// Copyright (c) 2020 Sendanor. All rights reserved.

import React from "react";
import "./Loader.scss";
import {ReactComponent as LoadingIcon} from "./loading.svg";

export interface LoaderProps {

    className?: string;

    speed?: number;

    /**
     * Time in milliseconds until the loader will be displayed to the user
     */
    hiddenTime?: number;

}

export interface LoaderState {

    hidden: boolean;

}

/**
 * Loader component.
 *
 * Part of Sendanor's Commercial NorJS React Components. Not a stable release.
 *
 * Copyright 2020 Jaakko-Heikki Heusala <jheusala@iki.fi>
 *           2020 Sendanor <info@sendanor.fi>
 */
export class Loader extends React.Component<LoaderProps, LoaderState> {

    static defaultProps : Partial<LoaderProps> = {

        speed: 1.6,

        hiddenTime: 500

    };

    private hiddenTimeout : any;

    constructor(props : LoaderProps) {

        super(props);

        this.state = {
            hidden: (this.props.hiddenTime ?? -1) >= 0
        };

        this.hiddenTimeout = undefined;

    }

    componentDidMount() {

        const hiddenTime = this.props.hiddenTime ?? -1;

        if (hiddenTime >= 0) {

            this.hiddenTimeout = setTimeout(() => {

                this.hiddenTimeout = undefined;

                this.setState({
                    hidden: false
                });

            }, hiddenTime);

        }

    }

    componentWillUnmount() {

        if (this.hiddenTimeout !== undefined) {
            clearTimeout(this.hiddenTimeout);
            this.hiddenTimeout = undefined;
        }

    }

    render () {

        const loadingIcon = this.state.hidden ? '' : <LoadingIcon />;

        return (
            <div className={ 'Loader ' + (this.props.className ?? '')}>

                <div className={'Loader-icon-container'}
                     style={{animation: `spin ${this.props.speed}s linear infinite`}}
                >{loadingIcon}</div>

            </div>
        );

    }

}

export default Loader;
